import { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Check, Warning, X } from '@phosphor-icons/react';
import api from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import Logo from '../components/Logo';

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const { user } = useAuth();
  const token = searchParams.get('token');
  const statusParam = searchParams.get('status');
  const [status, setStatus] = useState(statusParam || (token ? 'loading' : 'error'));
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    if (!token) return;

    api.get(`/auth/verify-email?token=${token}`)
      .then(() => setStatus('success'))
      .catch((err) => {
        setStatus(err.response?.status === 400 ? 'expired' : 'error');
      });
  }, [token]);

  // Contagem regressiva e redirect ao verificar com sucesso
  useEffect(() => {
    if (status !== 'success') return;

    const interval = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          if (user) {
            const saved = JSON.parse(localStorage.getItem('user') || '{}');
            localStorage.setItem('user', JSON.stringify({ ...saved, emailVerified: true }));
          }
          window.location.href = user ? '/dashboard' : '/login';
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [status, user]);

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-sm text-center">
        <div className="mb-8">
          <Logo />
        </div>

        {status === 'loading' ? (
          <>
            <svg className="w-8 h-8 text-blue-500 animate-spin mx-auto mb-4" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
            </svg>
            <h2 className="text-xl font-bold text-slate-800">Verificando...</h2>
          </>
        ) : status === 'success' ? (
          <>
            <div className="w-14 h-14 rounded-full bg-emerald-50 flex items-center justify-center mx-auto mb-4">
              <Check size={28} className="text-emerald-600" />
            </div>
            <h2 className="text-xl font-bold text-slate-800 mb-2">Email verificado!</h2>
            <p className="text-sm text-slate-400">Redirecionando em {countdown}s...</p>
          </>
        ) : status === 'expired' ? (
          <>
            <div className="w-14 h-14 rounded-full bg-amber-50 flex items-center justify-center mx-auto mb-4">
              <Warning size={28} className="text-amber-500" />
            </div>
            <h2 className="text-xl font-bold text-slate-800 mb-2">Link expirado</h2>
            <p className="text-sm text-slate-400 mb-6">Este link de verificacao expirou. Faca login e solicite um novo.</p>
            <Link
              to="/login"
              className="inline-block bg-blue-600 text-white px-6 py-2.5 rounded-xl hover:bg-blue-700 transition text-sm font-medium"
            >
              Voltar ao login
            </Link>
          </>
        ) : (
          <>
            <div className="w-14 h-14 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-4">
              <X size={28} className="text-red-500" />
            </div>
            <h2 className="text-xl font-bold text-slate-800 mb-2">Erro na verificacao</h2>
            <p className="text-sm text-slate-400 mb-6">Algo deu errado. Tente novamente.</p>
            <Link
              to="/login"
              className="inline-block bg-blue-600 text-white px-6 py-2.5 rounded-xl hover:bg-blue-700 transition text-sm font-medium"
            >
              Voltar ao login
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
